import { createSlice } from "@reduxjs/toolkit";
import { getCustomersAction } from "redux/action/customerAction";
import { toastText } from "utils/utils";

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

const CustomerSlice = createSlice({
  name: "company",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get All Users
    builder.addCase(getCustomersAction.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(getCustomersAction.fulfilled, (state, action) => {
      state.data = action?.payload;
      state.isLoading = false;
      state.error = null;
      toastText("Successfully fetched customer list.", "success");
    });
    builder.addCase(getCustomersAction.rejected, (state, action: any) => {
      state.error = action.payload;
      state.isLoading = false;
      toastText(action?.payload?.message, "error");
    });
  },
});

export default CustomerSlice;
